import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationsService, SpinnerComponent as Spinner} from '@westjetairlines/wjesd-component-library';
import {isNullOrUndefined} from 'util';
import {BaseStepComponent} from '../base-step/base-step.component';
import {IATA_SERVICE_TOKEN} from '../../shared/services/iata.service';
import {WORKFLOW_DATA_SERVICE_TOKEN} from '../../shared/services/workflow-data.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {Iata} from '../../shared/models/iata';

@Component({
  selector: 'app-iata-step',
  templateUrl: './iata-step.component.html',
  styleUrls: ['./iata-step.component.css']
})
export class IataStepComponent extends BaseStepComponent implements OnInit, OnDestroy {
  public iataCode: string;
  public iataOverride: boolean;
  public iataComments: string;
  private subscription: any;
  public overrideIataMode: boolean;
  private iataOverrideMessage: string =
    ` <br/><br/>This agency is to self-serve any controllable waiver requests. If you would like to continue with an uncontrolled waiver request, please select to proceed with waiver creation and indicate the reason for the exception in the comments section below. 
      <br/><br/>This waiver will be audited.
      <br/><br/>Please click Create Waiver link to start again.`;

  constructor(route: ActivatedRoute, @Inject(IATA_SERVICE_TOKEN) private iataService, private notificationService: NotificationsService,
              router: Router, @Inject(WORKFLOW_DATA_SERVICE_TOKEN) private workflowDataService,
              navigationService: NavigationService) {
    super(route, navigationService, router);
  }

  ngOnInit() {
    this.subscription =  this.workflowDataService.getTicketingIata.subscribe(data => {
      this.iataCode = isNullOrUndefined(data) || isNullOrUndefined(data.iataCode) ? null : data.iataCode;
      this.iataOverride = isNullOrUndefined(data) || isNullOrUndefined(data.iataOverride) ? false : data.iataOverride;
      this.iataComments = isNullOrUndefined(data) || isNullOrUndefined(data.iataComments) ? null : data.iataComments;
      this.overrideIataMode = isNullOrUndefined(data) || isNullOrUndefined(data.iataOverride) ? false : data.iataOverride;
    });
  }

  setTicketingIata() {
    let iata = new Iata(this.iataCode, this.iataOverride, this.iataComments);
    this.workflowDataService.setTicketingIata(iata);
  }

  lookupIata() {
    Spinner.start();
    this.iataService.isNonRestrictedIata(this.iataCode).subscribe(result => {
        if (result.wasSuccessful || (this.iataOverride && this.iataComments.length > 0)) {
          this.setTicketingIata();
          this.moveNext();
        }
        else {
          this.notificationService.error(result.brokenRules[0].message + this.iataOverrideMessage);
        }
        this.overrideIataMode = !result.wasSuccessful;
      },
      err => {
        Spinner.stop();
      },
      () => {
        Spinner.stop();
      });
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/steps/iata-step/iata-step.component.ts